/* ===== PATTES & SOIN — Tiroir panier + page panier : API panier native =====
   Adapte de assets/aventuscope-cart.js (theme actif publie).

   HISTORIQUE (2026-08-15) : le selecteur de paliers de la fiche "Brosse
   Attrape-Poils" etait gere par l'app tierce Moon Bundles (widget injecte,
   attribut data-ps-form pour dire a ce script "ne touche pas, l'app gere").
   Deux bugs confirmes avec cette app : (1) double-soumission du formulaire
   pour un seul clic (x1 devenait x2 au panier), (2) la remise -15% affichee
   dans le widget n'etait jamais appliquee au panier reel (purement visuelle).
   DECISION : le selecteur de paliers a ete reconstruit en dur dans
   sections/pattes-product-main.liquid (bloc [data-ps-bundle], radios
   [data-ps-bundle-radio], formulaire [data-ps-bundle-form]), avec sa propre
   logique de soumission (script dedie dans la section, technique de fetch
   "propre" via iframe deja validee sur Aventuscope). Ce fichier n'a donc
   plus besoin de gerer Moon Bundles specifiquement, mais reste compatible
   avec l'ancien marqueur data-ps-form si jamais reintroduit ailleurs.

   BUG #2 CONFIRME EN DIRECT (2026-08-15) : sur la page /cart, les boutons +/-
   et "Retirer" semblaient ne rien faire. Diagnostic : ils fonctionnaient tres
   bien cote serveur (le panier reel etait bien modifie, verifie via /cart.js),
   mais renderCartPage() essayait de rafraichir l'affichage via /cart?section_id=main
   (puis /cart?sections=main), et CES DEUX ENDPOINTS RENVOIENT SYSTEMATIQUEMENT
   DU VIDE (404, puis {"main":null}) sur la route /cart — verifie identique sur
   CE theme ET sur le theme Aventuscope (theme de reference qui "fonctionne"),
   donc ce n'est pas un bug de notre section pattes-cart-page : c'est une
   limite de la route /cart elle-meme pour le rendu de section a la demande sur
   cette boutique. Le tiroir panier (render(), depuis la racine "/") n'a lui
   aucun probleme : /?section_id=pattes-cart-drawer renvoie du contenu correct
   des 2 cotes. Fix : renderCartPage() ne passe plus par l'API de section a la
   demande ; elle recharge la page /cart elle-meme (chemin deja confirme
   fonctionnel par une navigation normale) et en extrait .ps-cartpage.

   AJOUT (2026-08-18) : notre flux d'ajout au panier passe par fetch()
   personnalise (post() ci-dessous, et le fetch "propre" via iframe dans
   pattes-product-main.liquid), ce qui contourne la soumission native du
   formulaire /cart/add. Consequence : l'evenement Shopify Analytics standard
   "product_added_to_cart" ne se declenche jamais tout seul, donc les pixels
   publicitaires (Meta, Google, TikTok...) qui ecoutent cet evenement ne
   voient jamais nos ajouts au panier. Fix : apres chaque appel reussi a
   /cart/add.js, on publie manuellement l'evenement via
   window.Shopify.analytics.publish (si present) et on emet aussi un
   evenement DOM custom "cart:add" (bubbles: true) pour tout script/app tiers
   qui preferrerait ecouter le DOM plutot que l'API Shopify Analytics.

   CORRECTIF (2026-08-18, meme jour) : verifie en direct que meme apres le
   fix ci-dessus, AUCUN appel reseau vers Facebook ne partait (page view OK,
   add to cart absent). Cause reelle : window.Shopify.analytics.publish
   attend un objet "cartLine" au format Web Pixels (cost.totalAmount,
   merchandise.product, merchandise.price...), pas le format brut renvoye par
   /cart/add.js (line_price, variant_id, product_id... a plat). L'appel ne
   plantait pas, mais les pixels abonnes a cet evenement (Meta, Google...) ne
   recevaient rien d'exploitable et n'envoyaient donc jamais leur conversion
   AddToCart. Fix : toWebPixelCartLine() reconstruit un objet conforme avant
   publication.

   CORRECTIF (2026-09-07) : le bouton "Appliquer" du code de reduction faisait
   une navigation complete (window.location.href vers /discount/CODE?redirect=...)
   puis comptait sur ?cart=open + DOMContentLoaded pour rouvrir le tiroir sur la
   page de retour. En pratique ce rechargement complet pouvait repartir d'un
   cache navigateur/CDN pas a jour et donnait l'impression que le panier avait
   ete perdu (l'acheteur croyait devoir tout rajouter). Fix : on applique le
   code via fetch() (le cookie de remise est pose par la reponse, meme sans
   suivre la redirection dans le DOM), puis on rafraichit le tiroir/la page
   panier sur place (refresh() + renderCartPage()), sans jamais quitter la
   page ni fermer le tiroir. */
(function () {
  'use strict';

  /* ---------- Anti double-soumission (garde-fou generique) ----------
     Ecoute en PHASE DE CAPTURE (donc executee avant tout gestionnaire pose
     par une app tierce en phase de bulle, et avant la soumission native du
     formulaire) : si le meme formulaire marque data-ps-form OU
     data-ps-bundle-form recoit un 2e evenement submit dans les 1500ms
     suivant le premier, on l'annule completement (preventDefault +
     stopImmediatePropagation). Une soumission normale et unique n'est
     jamais affectee. Conserve par securite meme si le bundle Moon Bundles
     n'est plus utilise sur ce produit (voir commentaire en tete de fichier). */
  var lastSubmitAt = new WeakMap();
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"][data-ps-form], form[action*="/cart/add"][data-ps-bundle-form]')) return;
    var now = Date.now();
    var last = lastSubmitAt.get(form) || 0;
    if (now - last < 1500) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      console.warn('[ps-cart] soumission dupliquee bloquee —', Math.round(now - last), 'ms apres la precedente');
      return;
    }
    lastSubmitAt.set(form, now);
  }, true);

  var SECTION_ID = 'pattes-cart-drawer';
  var TIMER_KEY = 'ps_cart_deadline';
  var timerHandle = null;

  function el() { return document.querySelector('[data-ps-drawer]'); }

  /* ---------- Analytics : publie un ajout au panier pour les pixels tiers ----------
     Notre flux d'ajout passe par fetch() perso (post() ci-dessous), donc
     l'evenement natif Shopify ne se declenche jamais tout seul — on le
     republie nous-memes ici, plus un evenement DOM custom en secours.

     toWebPixelCartLine() convertit le line_item brut renvoye par
     /cart/add.js vers le format "CartLine" attendu par les Web Pixels
     Shopify (cost.totalAmount, merchandise.product, merchandise.price...).
     Sans cette conversion, Shopify.analytics.publish ne plante pas mais les
     pixels (Meta, Google...) ne recoivent rien d'exploitable. */
  function toWebPixelCartLine(lineItem) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var imgUrl = (lineItem.featured_image && lineItem.featured_image.url) || lineItem.image || null;
    return {
      cost: {
        totalAmount: {
          amount: (lineItem.line_price / 100),
          currencyCode: currency
        }
      },
      merchandise: {
        id: 'gid://shopify/ProductVariant/' + lineItem.variant_id,
        image: imgUrl ? { src: imgUrl } : null,
        price: {
          amount: (lineItem.price / 100),
          currencyCode: currency
        },
        product: {
          id: 'gid://shopify/Product/' + lineItem.product_id,
          title: lineItem.product_title || lineItem.title,
          untranslatedTitle: lineItem.product_title || lineItem.title,
          vendor: lineItem.vendor || '',
          url: lineItem.url || '',
          type: lineItem.product_type || ''
        },
        selectedOptions: (lineItem.options_with_values || []).map(function (o) {
          return { name: o.name, value: o.value };
        }),
        sku: lineItem.sku || '',
        title: lineItem.variant_title || lineItem.title,
        untranslatedTitle: lineItem.variant_title || lineItem.title
      },
      quantity: lineItem.quantity
    };
  }

  /* CORRECTIF (2026-09-07) : verifie en direct sur pattesandsoin.com que
     Shopify.analytics.publish() ci-dessous ne fait remonter AUCUN AddToCart
     ni cote Meta ni cote Shopify (eventCount du pixel Meta inchange apres un
     ajout reel, aucune requete reseau vers facebook.com/tr), alors meme que
     window.fbq existe sur la page et que le consentement est accepte. Fix :
     appel DIRECT a window.fbq('track', 'AddToCart', ...) en plus, avec un
     eventID unique transmis aussi dans le detail de "cart:add" pour servir
     de cle de deduplication cote gestionnaire d'evenements Meta si un
     evenement serveur (Conversions API) est ajoute plus tard. */
  function genEventId() {
    return 'atc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function publishMetaAddToCart(lineItem, eventId) {
    if (typeof window.fbq !== 'function') return;
    try {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      var variantId = String(lineItem.variant_id || lineItem.id);
      window.fbq('track', 'AddToCart', {
        content_ids: [variantId],
        content_type: 'product',
        content_name: lineItem.product_title || lineItem.title,
        contents: [{ id: variantId, quantity: lineItem.quantity }],
        value: (lineItem.line_price || (lineItem.price * lineItem.quantity)) / 100,
        currency: currency
      }, { eventID: eventId });
    } catch (err) {
      console.warn('[ps-cart] fbq AddToCart', err);
    }
  }

  function announceCartAdd(lineItem) {
    if (!lineItem) return;
    var eventId = genEventId();
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('product_added_to_cart', { cartLine: toWebPixelCartLine(lineItem) });
      }
    } catch (err) {
      console.warn('[ps-cart] analytics publish', err);
    }
    publishMetaAddToCart(lineItem, eventId);
    document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { cartLine: lineItem, eventId: eventId } }));
  }

  /* ---------- Ouverture / fermeture ---------- */
  function open() {
    var d = el(); if (!d) return;
    document.querySelectorAll('#cart-drawer dialog[open]').forEach(function (dialog) { dialog.close(); });
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    var d = el(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function setLoading(s) {
    var d = el(); if (d) d.classList.toggle('is-loading', !!s);
  }

  /* ---------- Compte a rebours du tiroir, persiste entre les pages ---------- */
  function startTimer() {
    var d = el(); if (!d) return;
    var span = d.querySelector('[data-ps-timer]');
    if (!span) return;

    var minutes = parseInt(d.getAttribute('data-countdown'), 10);
    if (!minutes || minutes <= 0) return;

    var deadline = parseInt(sessionStorage.getItem(TIMER_KEY), 10);
    if (!deadline || isNaN(deadline) || deadline < Date.now()) {
      deadline = Date.now() + minutes * 60 * 1000;
      sessionStorage.setItem(TIMER_KEY, String(deadline));
    }

    if (timerHandle) clearInterval(timerHandle);
    function tick() {
      var live = el();
      var target = live && live.querySelector('[data-ps-timer]');
      if (!target) { clearInterval(timerHandle); return; }
      var left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      var m = String(Math.floor(left / 60)).padStart(2, '0');
      var s = String(left % 60).padStart(2, '0');
      target.textContent = m + ':' + s;
    }
    tick();
    timerHandle = setInterval(tick, 1000);
  }

  /* ---------- Cadeau automatique (desactive par defaut, aucun produit cadeau) ---------- */
  function giftConfig() {
    var d = el(); if (!d) return null;
    var variant = d.getAttribute('data-gift-variant');
    var threshold = parseInt(d.getAttribute('data-gift-threshold'), 10);
    if (!variant || !threshold || threshold <= 0) return null;
    return { variant: Number(variant), threshold: threshold };
  }

  function syncGift() {
    var cfg = giftConfig();
    if (!cfg) return Promise.resolve(false);

    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var giftKey = null, giftQty = 0, totalNoGift = 0;
      cart.items.forEach(function (i) {
        if (i.variant_id === cfg.variant) { giftKey = i.key; giftQty = i.quantity; }
        else { totalNoGift += i.final_line_price; }
      });
      var eligible = totalNoGift >= cfg.threshold;

      if (eligible && giftQty === 0) {
        return post('/cart/add.js', { items: [{ id: cfg.variant, quantity: 1, properties: { _cadeau: 'true' } }] }).then(function () { return true; });
      }
      if (!eligible && giftQty > 0) {
        return post('/cart/change.js', { id: giftKey, quantity: 0 }).then(function () { return true; });
      }
      if (eligible && giftQty > 1) {
        return post('/cart/change.js', { id: giftKey, quantity: 1 }).then(function () { return true; });
      }
      return false;
    }).catch(function () { return false; });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* ---------- Rendu du tiroir ---------- */
  function render() {
    return fetch('/?section_id=' + SECTION_ID, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ps-drawer]');
        var current = el();
        if (!fresh || !current) return;
        var wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        ['data-gift-variant', 'data-gift-threshold', 'data-countdown'].forEach(function (a) {
          if (fresh.hasAttribute(a)) current.setAttribute(a, fresh.getAttribute(a));
        });
        if (wasOpen) current.classList.add('is-open');
        updateBubble();
        startTimer();
      })
      .catch(function (e) { console.warn('[ps-cart] render', e); });
  }

  function refresh() { return syncGift().then(render); }

  /* Re-rend aussi la page /cart elle-meme (sections/pattes-cart-page.liquid) si
     elle est presente sur la page courante, pour rester synchro avec le tiroir.
     Ne passe PAS par /cart?section_id=main ni /cart?sections=main : ces deux
     endpoints renvoient du vide sur cette boutique (verifie identique sur le
     theme Aventuscope de reference, voir commentaire en tete de fichier). On
     recharge donc la page /cart elle-meme et on en extrait .ps-cartpage. */
  function renderCartPage() {
    var current = document.querySelector('.ps-cartpage');
    if (!current) return Promise.resolve();
    return fetch(location.pathname + location.search, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.ps-cartpage');
        var live = document.querySelector('.ps-cartpage');
        if (!fresh || !live) return;
        live.replaceWith(fresh);
      })
      .catch(function (e) { console.warn('[ps-cart] renderCartPage', e); });
  }

  /* 2026-10-11 : ne plus ecrire dans .cart-bubble__text. Ca effacait <span ref="cartBubbleCount">
     et faisait planter le composant <cart-icon> d'Horizon a chaque chargement de page
     (« Required ref cartBubbleCount not found in component cart-icon » = 71 % des erreurs JS Clarity).
     On passe par le composant lui-meme ; sinon on ne touche qu'au compteur. */
  function updateBubble() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var n = cart.item_count;
      document.querySelectorAll('cart-icon').forEach(function (icon) {
        if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(n, false);
      });
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-bubble__text-count')
        .forEach(function (el) {
          var icon = el.closest('cart-icon');
          if (icon && typeof icon.renderCartBubble === 'function') return;
          el.textContent = n;
        });
    }).catch(function () {});
  }

  /* ---------- Actions ---------- */
  function changeKey(key, qty) {
    setLoading(true);
    return post('/cart/change.js', { id: key, quantity: qty })
      .then(refresh).then(renderCartPage).finally(function () { setLoading(false); });
  }

  function addVariant(id, qty, props) {
    setLoading(true);
    var item = { id: Number(id), quantity: qty || 1 };
    if (props) item.properties = props;
    return post('/cart/add.js', { items: [item] })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.line_item) announceCartAdd(res.line_item);
        return res;
      })
      .then(refresh).then(renderCartPage)
      .finally(function () { setLoading(false); });
  }

  function swapVariant(key, newVariantId, qty) {
    setLoading(true);
    return post('/cart/change.js', { id: key, quantity: 0 })
      .then(function () { return post('/cart/add.js', { items: [{ id: Number(newVariantId), quantity: qty }] }); })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.line_item) announceCartAdd(res.line_item);
        return res;
      })
      .then(refresh).then(renderCartPage)
      .finally(function () { setLoading(false); });
  }

  function removeProduct(productId) {
    setLoading(true);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var keys = cart.items.filter(function (i) { return String(i.product_id) === String(productId); })
                           .map(function (i) { return i.key; });
      return keys.reduce(function (chain, k) {
        return chain.then(function () { return post('/cart/change.js', { id: k, quantity: 0 }); });
      }, Promise.resolve());
    }).then(refresh).then(renderCartPage).finally(function () { setLoading(false); });
  }

  function bumpProduct(key, dir) {
    setLoading(true);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!line) return;
      if (dir === 'plus') {
        return post('/cart/add.js', { items: [{ id: line.variant_id, quantity: 1 }] })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.line_item) announceCartAdd(res.line_item);
            return res;
          });
      }
      return post('/cart/change.js', { id: key, quantity: Math.max(0, line.quantity - 1) });
    }).then(refresh).then(renderCartPage).finally(function () { setLoading(false); });
  }

  /* ---------- Code de reduction : applique sans quitter la page ----------
     Avant : window.location.href vers /discount/CODE?redirect=... (navigation
     complete, cf. correctif du 2026-09-07 en tete de fichier). Maintenant :
     un fetch() same-origin sur /discount/CODE pose le cookie de remise
     exactement pareil (Shopify n'exige pas de suivre la redirection dans le
     DOM pour que le cookie soit accepte), puis on rafraichit juste le tiroir
     et la page panier sur place. Le tiroir reste ouvert, rien n'est perdu,
     l'acheteur n'a jamais besoin de rajouter l'article. */
  function applyDiscountCode(code, button) {
    setLoading(true);
    if (button) button.disabled = true;
    var originalLabel = button ? button.textContent : null;
    if (button) button.textContent = '...';
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(refresh)
      .then(renderCartPage)
      .catch(function (err) { console.warn('[ps-cart] applyDiscountCode', err); })
      .finally(function () {
        setLoading(false);
        if (button) { button.disabled = false; button.textContent = originalLabel; }
      });
  }

  /* ---------- Evenements ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-ps-close]')) { e.preventDefault(); close(); return; }

    var toggle = t.closest('[data-ps-toggle]');
    if (toggle) {
      e.preventDefault();
      var body = toggle.parentElement.querySelector('[data-ps-variants]');
      var label = toggle.querySelector('.ps-cart-drawer__toggle-label');
      var openNow = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!openNow));
      if (body) body.hidden = openNow;
      if (label) {
        var n = label.textContent.replace(/\D+/g, '');
        label.textContent = (openNow ? 'Voir les ' : 'Masquer les ') + n + ' articles';
      }
      return;
    }

    var qtyBtn = t.closest('[data-ps-qty]');
    if (qtyBtn) {
      e.preventDefault();
      bumpProduct(qtyBtn.getAttribute('data-key'), qtyBtn.getAttribute('data-ps-qty'));
      return;
    }

    var rmProduct = t.closest('[data-ps-remove-product]');
    if (rmProduct) {
      e.preventDefault();
      removeProduct(rmProduct.getAttribute('data-ps-remove-product'));
      return;
    }

    var addBtn = t.closest('[data-ps-add]');
    if (addBtn) {
      e.preventDefault();
      addBtn.disabled = true;
      addBtn.textContent = 'Ajouté';
      addVariant(addBtn.getAttribute('data-ps-add'), 1).then(open);
      return;
    }

    var applyBtn = t.closest('[data-ps-apply]');
    if (applyBtn) {
      e.preventDefault();
      var scope = applyBtn.closest('.ps-cart-drawer, .ps-cartpage') || document;
      var input = scope.querySelector('[data-ps-code]');
      var code = input && input.value.trim();
      if (!code) return;
      applyDiscountCode(code, applyBtn);
      return;
    }

    /* ---------- Coupon livraison : copie le code + pre-remplit le champ ----------
       Ajoute a la demande le 30/08/2026 : bouton "Copier" affiche pres de la barre
       "plus que X€ pour la livraison offerte" tant que le seuil n'est pas atteint.
       Copie le code dans le presse-papiers ET pre-remplit le champ [data-ps-code]
       par securite (au cas ou navigator.clipboard serait indisponible/refuse). */
    var copyBtn = t.closest('[data-ps-copy-code]');
    if (copyBtn) {
      e.preventDefault();
      var couponCode = copyBtn.getAttribute('data-ps-copy-code');
      var copyScope = copyBtn.closest('.ps-cart-drawer, .ps-cartpage') || document;
      var copyLabel = copyBtn.querySelector('[data-ps-copy-label]');
      var previousLabel = copyLabel ? copyLabel.textContent : null;

      var showCopied = function () {
        var codeInput = copyScope.querySelector('[data-ps-code]');
        if (codeInput) codeInput.value = couponCode;
        copyBtn.classList.add('is-copied');
        if (copyLabel) copyLabel.textContent = 'Copié !';
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (copyLabel && previousLabel) copyLabel.textContent = previousLabel;
        }, 1800);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(couponCode).then(showCopied).catch(showCopied);
      } else {
        showCopied();
      }
      return;
    }

    var cartLink = t.closest('a[href$="/cart"], a[href*="/cart?"], [data-cart-icon], .header-actions__cart, cart-icon');
    if (cartLink) { e.preventDefault(); refresh().then(open); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-ps-variant]');
    if (sel) {
      swapVariant(sel.getAttribute('data-key'), sel.value, parseInt(sel.getAttribute('data-qty'), 10) || 1);
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* Ouvre le tiroir apres un ajout AJAX reussi — mais JAMAIS pour les formulaires
     marques data-ps-form ou data-ps-bundle-form (geres par leur propre logique
     dediee, cf. commentaire en tete de fichier). Pour tous les AUTRES formulaires
     produit du site (sans selecteur de paliers), le tiroir s'ouvre normalement
     apres ajout. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-ps-form') || form.hasAttribute('data-ps-bundle-form')) return;
    e.preventDefault();
    setLoading(true);
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { console.warn('[ps-cart]', res.description || res.message); return; }
        if (res && res.line_item) announceCartAdd(res.line_item);
        return refresh().then(open);
      })
      .catch(function (err) { console.warn('[ps-cart] add', err); })
      .finally(function () { setLoading(false); });
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateBubble();
    startTimer();
    syncGift().then(function (changed) { if (changed) render(); });
    if (new URLSearchParams(location.search).get('cart') === 'open') refresh().then(open);
  });

  window.psCart = { open: open, close: close, refresh: refresh };
})();